import { useEffect } from 'react';

const options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
};

function errors(err) {
  console.warn(`ERROR(${err.code}): ${err.message}`);
}

const Geolocation = ({ setUserLocation }) => {
  function success(pos) {
    var crd = pos.coords;

    console.log('Your current position is:');
    console.log(`Latitude : ${crd.latitude}`);
    console.log(`Longitude: ${crd.longitude}`);
    console.log(`More or less ${crd.accuracy} meters.`);

    setUserLocation({ lat: crd.latitude, lng: crd.longitude });
  }
  useEffect(() => {
    if (navigator?.geolocation) {
      if (navigator.permissions && navigator.permissions.query) {
        navigator?.permissions
          .query({ name: 'geolocation' })
          .then(function (result) {
            if (result.state === 'granted') {
              console.log(45, result.state);
              //If granted then you can directly call your function here
              navigator.geolocation.getCurrentPosition(success);
            } else if (result.state === 'prompt') {
              console.log(89, result.state);
              navigator.geolocation.getCurrentPosition(
                success,
                errors,
                options
              );
            } else if (result.state === 'denied') {
              //If denied then you have to show instructions to enable location
            }
            result.onchange = function () {
              console.log(result.state);
            };
          });
      }
    } else {
      alert('Sorry Not available!');
    }
  }, []);
  return <div></div>;
};

export default Geolocation;
